// Path: frontend/src/pages/admin/ChatRecordsAnalysisPage.tsx

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Layers, FileText, Code, MessageCircle } from 'lucide-react';
import LogoutButton from '../../components/common/LogoutButton';
import { SlideChatRecordsTab, PlanChatRecordsTab, VibeChatRecordsTab, SalesChatRecordsTab } from './components/chat-records';

type TabType = 'slide' | 'plan' | 'vibe' | 'sales';

interface TabConfig {
  key: TabType;
  label: string;
  icon: React.ReactNode;
}

const tabs: TabConfig[] = [
  { key: 'slide', label: 'Slide教研记录', icon: <Layers size={16} /> },
  { key: 'plan', label: 'Plan教研记录', icon: <FileText size={16} /> },
  { key: 'vibe', label: 'Vibe Coding记录', icon: <Code size={16} /> },
  { key: 'sales', label: 'Sales记录', icon: <MessageCircle size={16} /> },
];

const ChatRecordsAnalysisPage: React.FC = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<TabType>('slide');

  const renderTabContent = () => {
    switch (activeTab) {
      case 'slide':
        return <SlideChatRecordsTab />;
      case 'plan':
        return <PlanChatRecordsTab />;
      case 'vibe':
        return <VibeChatRecordsTab />;
      case 'sales':
        return <SalesChatRecordsTab />;
      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white border-b sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
          <div className="flex items-center gap-4">
            <button
              onClick={() => navigate('/admin')}
              className="flex items-center gap-2 px-3 py-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <ArrowLeft size={18} />
              返回
            </button>
            <h1 className="text-xl font-bold text-gray-800">教研聊天记录分析</h1>
          </div>
          <div className="flex items-center gap-3">
            <LogoutButton />
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 py-6">
        <div className="mb-6">
          <div className="border-b border-gray-200">
            <nav className="-mb-px flex space-x-8">
              {tabs.map(tab => (
                <button
                  key={tab.key}
                  onClick={() => setActiveTab(tab.key)}
                  className={`
                    flex items-center gap-2 py-4 px-1 border-b-2 font-medium text-sm transition-colors
                    ${activeTab === tab.key
                      ? 'border-brand-500 text-brand-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }
                  `}
                >
                  {tab.icon}
                  {tab.label}
                </button>
              ))}
            </nav>
          </div>
        </div>

        {renderTabContent()}
      </main>
    </div>
  );
};

export default ChatRecordsAnalysisPage;
